const FETCH_PASSKEYS_STARTED = "FETCH_PASSKEYS_STARTED";
const FETCH_PASSKEYS_SUCCEEDED = "FETCH_PASSKEYS_SUCCEEDED";
const FETCH_PASSKEYS_FAILED = "FETCH_PASSKEYS_FAILED";

export { FETCH_PASSKEYS_STARTED, FETCH_PASSKEYS_SUCCEEDED, FETCH_PASSKEYS_FAILED };
